import type { HTMLAttributes, PropsWithChildren } from "react";

import { TIconKey } from "../Icon";
import { DefinedDefaults } from "@/ui/lib";

/*-------------------------------------
|  Constants
-------------------------------------*/

export const PILL_VARIANT_CLASS_MAP = {
  default: "border-component-pill-default bg-component-pill-default text-foreground",
  price: "border-component-pill-price bg-component-pill-price text-foreground",
  benefit: "border-component-pill-benefit bg-component-pill-benefit text-foreground",
  warning: "border-component-pill-warning bg-component-pill-warning text-functional-warning",
  destructive: "border-component-pill-destructive bg-component-pill-destructive text-functional-destructive",
} as const;

/*-------------------------------------
|  Types
-------------------------------------*/

export type TPillVariant = keyof typeof PILL_VARIANT_CLASS_MAP;

export type TPillProps = {
  variant?: TPillVariant;
  icon?: TIconKey;
} & PropsWithChildren & HTMLAttributes<HTMLDivElement>;


/* Boilerplate  */
type TPillDefaultProps = DefinedDefaults<TPillProps, "variant">;

/*-------------------------------------
|  Defaults
-------------------------------------*/

export const PILL_DEFAULTS = {
  variant: "default",
} satisfies TPillDefaultProps;
